import { z } from 'zod';
export const forwarderSchema = z.object({
  address: z.string().min(1, 'Source is required').email('Enter a valid source address'),
  destinations: z.array(z.string().email('Enter valid addresses')).min(1, 'At least one destination'),
  keepCopy: z.boolean().default(false),
  enabled: z.boolean().default(true),
});
export type ForwarderFormValues = z.infer<typeof forwarderSchema>;
